/**
 * Indicador de ordenación (↑/↓) para columnas sortable de AdminTableShell.
 *
 * Renderiza SVG inline (nunca emoji) siguiendo regla de iconografía.
 */

import { C } from '@/lib/design';

export type SortDirection = 'asc' | 'desc' | null;

interface AdminSortIndicatorProps {
  direction: SortDirection;
}

export function AdminSortIndicator({ direction }: AdminSortIndicatorProps) {
  const active = direction !== null;
  const color = active ? '#FFFFFF' : 'rgba(255,255,255,0.4)';

  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        marginLeft: 4,
        lineHeight: 0,
        color,
      }}
    >
      <svg
        width="8"
        height="5"
        viewBox="0 0 8 5"
        fill="none"
        style={{ opacity: direction === 'asc' ? 1 : 0.4, marginBottom: 1 }}
      >
        <path d="M4 0L8 5H0L4 0Z" fill={direction === 'asc' ? '#FFFFFF' : C.celeste} />
      </svg>
      <svg
        width="8"
        height="5"
        viewBox="0 0 8 5"
        fill="none"
        style={{ opacity: direction === 'desc' ? 1 : 0.4 }}
      >
        <path d="M4 5L0 0H8L4 5Z" fill={direction === 'desc' ? '#FFFFFF' : C.celeste} />
      </svg>
    </span>
  );
}
